export default "__VITE_ASSET__BxOZ0ye8__"